import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import RequireAuth from "components/RequireAuth";
import { authStorage } from "services/authStorage";

const App = () => {
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="/admin"
        element={<Navigate to="/admin/default" replace />}
      />
      <Route
        path="admin/*"
        element={<RequireAuth requiredGuard="admin"><AdminLayout /></RequireAuth>}
      />
      <Route path="instructor/*" element={<Navigate to="/auth/admin-sign-in" replace />} />
      <Route path="rtl/*" element={<Navigate to="/auth/admin-sign-in" replace />} />
      <Route
        path="/"
        element={
          <Navigate
            to={authStorage.isAuthenticated("admin") ? "/admin/default" : "/auth/admin-sign-in"}
            replace
          />
        }
      />
    </Routes>
  );
};

export default App;
